var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFreeCancellation = function SvgFreeCancellation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5H5C3.89543 5 3 5.89543 3 7V19C3 20.1046 3.89543 21 5 21H11M7 5H17M7 5V3M7 5V7M17 5H19C20.1046 5 21 5.89543 21 7V11M17 5V3M17 5V7M7 10.5L17 10.5M15 15L18 18M18 18L21.0001 21M18 18L15 21M18 18L21.0001 15",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFreeCancellation;